<template>
  <button class="btn btn-link mb-2" type="button" @click="onClick">
    <i class="bi bi-file-earmark-arrow-down" /> {{ $t("exportar") }}
  </button>
</template>

<script>
import { getAllCodigosData } from '../codigoParceiroService.js';

export default {
  props: {
    headers: { type: Array, required: true },
    // eslint-disable-next-line vue/require-default-prop, vue/require-prop-types
    pagination: {
      sort: { type: String, required: true },
      order: { type: String, required: true },
      search: { type: String, default: '' },
    },
    idParceiro: { type: String, required: true },
  },
  methods: {
    async onClick() {
      const tempRows = await getAllCodigosData(this.pagination, this.idParceiro);
      const nomeParceiro = tempRows.length > 0 ? tempRows[0][1] : '';
      const rows = tempRows.map(function(val) {
        return val.slice(0, -1);
      });
      const content = 'data:text/csv;charset=utf-8,\ufeff' + rows.map((e) => e.join(';')).join('\n');
      const encodedUri = encodeURI(content);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', `códigos${nomeParceiro}.csv`);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
